<template>
  <div class="mt-5">
    <v-card class="d-flex pt-2 pb-2">
      <div class="card-sla">
        <strong>{{ tipoAgingName }}
          <SGPFormBotaoComponent round small :color="'red'" class="botao-multa"
            v-if="Number(valorMulta) !== 0" @click="abrirModalMulta = !abrirModalMulta"
            style="margin: 3px;">
            <span class="text-white">Alerta de multa</span>
          </SGPFormBotaoComponent>

        </strong>
      </div>

      <!-- Aging Tarefa -->
      <div class="card-sla">
        <div>
          <span class="title">
            {{ agingTarefa }}
          </span>
          <span class="sub-title">aging tarefa</span>
        </div>
        <div>
          <span class="sla">
            SLA
            <v-icon :color="slaStatusTarefa">
              {{ slaIcone(slaStatusTarefa) }}
            </v-icon>
          </span>
        </div>
      </div>

      <!-- Aging Workflow -->
      <div class="card-sla">
        <div>
          <span class="title">
            {{ agingWorkflow }}
          </span>
          <span class="sub-title">aging workflow</span>
        </div>
        <div>
          <span class="sla">
            SLA
            <v-icon :color="slaStatusWorkflow">
              {{ slaIcone(slaStatusWorkflow) }}
            </v-icon>
          </span>
        </div>
      </div>

      <!-- sla provedor -->
      <div class="card-sla" v-if="ehInstalacao">
        <div>
          <span class="title">
            {{ slaProvedor }}
          </span>
          <span class="sub-title">SLA provedor</span>
        </div>
      </div>

      <!-- SLA a vencer -->
      <!-- <div class="card-sla">
        <div>
          <span class="title" v-if="slaAVencer >= 0">
            {{ slaAVencer + ' ' + tipoAgingLabel }}
          </span>
          <span class="title" v-else>Vencido</span>
          <span class="sub-title">SLA a vencer</span>
        </div>
        <div>
          <span class="sla">
            SLA
            <v-icon :color="slaAVencer < 0 ? 'primary' : 'green'">
              mdi-check-circle
            </v-icon>
          </span>
        </div>
      </div> -->

      <SGPModalComponent v-model="abrirModalMulta" tamanho="sm" titulo="Aviso de multa" :mostrarFooter="false"
        v-if="abrirModalMulta" @sgpModalFechar="abrirModalMulta = false">
        <p>Veja abaixo os detalhes da multa:</p>
        <h5>Valor multa:  R$ {{ valorMulta }}</h5>
        <div class="d-flex align-items-center">
          <h5 class="m-0">Observações:</h5>
        </div>

        <button class="btn btn-secondary btn-sm mt-2" round small @click="mostrarCalculo = !mostrarCalculo">
          {{ mostrarCalculo ? 'Ocultar cálculo' : 'Mostrar cálculo' }}
        </button>

        <div v-if="mostrarCalculo" class="mt-2">
          <p><strong>VC = ( 3 × n × VM ) / 1440</strong></p>

          <p><strong>VC</strong> = Valor do Crédito (Desconto por Interrupção)</p>
          <p><strong>VM</strong> = Valor mensal do circuito interrompido</p>
          <p><strong>n</strong> = Quantidade de períodos de 30 min afetados</p>

          <p class="mt-2">
            Períodos fracionados ≥ 15 minutos são considerados como 30 minutos.
          </p>
        </div>
      </SGPModalComponent>
    </v-card>
  </div>
</template>

<style scoped>
.botao-multa {
  animation: brilho 1.5s infinite alternate;
}

@keyframes brilho {
  from {
    box-shadow: 0 0 4px rgba(255, 0, 0, 0.4);
  }

  to {
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.9);
  }
}
</style>

<script>
import { formatarSlaHoras } from '@/modules/workflow/ctrl-provedores/helpers/slaHelper';

export default {
  name: 'FichaTecnicaSLACards',

  props: {
    dadosFichaTecnica: {
      type: Object,
      required: true
    },
    circuito: {
      type: Object,
      default: () => ({})
    },
    tarefaSelecionada: {
      type: Object,
      default: () => ({})
    },
    provedorTipo: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      abrirModalMulta: false,
      mostrarCalculo: false
    }
  },

  methods: {
    slaIcone(status) {
      if (status === 'red') return 'mdi-close-circle';
      if (status === 'orange') return 'mdi-alert-circle';
      return 'mdi-check-circle';
    }
  },

  computed: {
    valorMulta() {
      return this.dadosFichaTecnica?.workflow?.valor_multa;
    },

    tipoAgingName() {
      return this.dadosFichaTecnica?.workflow?.ctrl_workflow?.tipo_aging?.tipo || '-';
    },

    tipoAging() {
      return this.dadosFichaTecnica?.workflow?.ctrl_workflow?.tipo_aging || null;
    },

    tipoAgingLabel() {
      if (!this.tipoAging) return 'dias';
      return this.tipoAging.coluna === 'aging_dias_uteis' ? 'dias úteis' : 'dias';
    },

    colunaAging() {
      return this.tipoAging?.coluna || 'aging_dias';
    },

    agingTarefa() {
      const aging = this.dadosFichaTecnica?.aging_minutos || 0;
      const agingFormatado = formatarSlaHoras(aging);
      // const label = this.colunaAging === 'aging_dias_uteis' ? 'dias úteis' : 'dias';
      return `${agingFormatado}`
        ;
    },

    agingWorkflow() {
      const workflow = this.dadosFichaTecnica?.workflow;
      if (!workflow) return '-';

      const aging = workflow?.aging_minutos || 0;
      const agingFormatado = formatarSlaHoras(aging);
      // const label = this.colunaAging === 'aging_dias_uteis' ? 'dias úteis' : 'dias';
      return `${agingFormatado}`
        ;
    },

    workflowDentroSla() {
      return this.dadosFichaTecnica?.workflow?.dentro_sla || false;
    },

    ehInstalacao() {
      return this.provedorTipo === 'provedor_instalacao';
    },

    slaProvedor() {
      const sla = this.circuito?.sla_provedor?.sla;
      return sla ? formatarSlaHoras(sla) : 'Não cadastrado';
    },

    slaTotal() {
      if (this.ehInstalacao) {
        return this.circuito?.sla_provedor?.sla ?? null;
      }
      return this.circuito?.designacao?.sla;
    },

    slaStatusTarefa() {
      const slaTotal = this.slaTotal;
      if (!slaTotal) return 'green';
      const agingAtual = this.dadosFichaTecnica?.aging_minutos || 0;
      if (agingAtual > slaTotal) return 'red';
      if (agingAtual >= (2 / 3) * slaTotal) return 'orange';
      return 'green';
    },

    slaStatusWorkflow() {
      const slaTotal = this.slaTotal;
      if (!slaTotal) return 'green';
      const agingAtual = this.dadosFichaTecnica?.workflow?.aging_minutos || 0;
      if (agingAtual > slaTotal) return 'red';
      if (agingAtual >= (2 / 3) * slaTotal) return 'orange';
      return 'green';
    },

    getCorSlaCircuito() {
      if (!this.circuito?.aging_dias_circuito_expurgo_cliente ||
        !this.circuito?.prazo_tipo_circuito_sla) {
        return 'green';
      }
      return (this.circuito.aging_dias_circuito_expurgo_cliente >
        this.circuito.prazo_tipo_circuito_sla) ? 'primary' : 'green';
    },

    slaAVencer() {
      const workflow = this.dadosFichaTecnica?.workflow;
      if (!workflow?.ctrl_workflow) return 0;

      const slaTotal = workflow.ctrl_workflow.aging || 0;
      const agingAtual = workflow[this.colunaAging] || 0;

      return slaTotal - agingAtual;
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #E3262E;

.card-sla {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-right: solid 1px #ddd;

  .title {
    color: $primary;
  }

  .sub-title {
    font-size: 12px;
    font-weight: 500;
    color: #666;
  }

  span {
    display: block;
  }

  .sla {
    color: #aaa;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &:last-child {
    border: none;
  }
}
</style>
